<template>
  <div :class="modalClass" tabindex="-1" role="dialog" id="workflowColumnSummaryModal">
    <div class="modal-dialog modal-md" role="document" id="workflowColumnSummaryModalDialog">
      <div class="modal-content" :style="borderRadius ? 'border-radius: ' + borderRadius + 'px' : ''">
        <div class="modal-header" v-if="summary">
          <h4 class="modal-title"><i class="fa fa-fw fa-info"></i> {{ summary.title }}</h4>
          <button type="button" class="close" data-dismiss="modal" :aria-label="_('Close')" v-on:click="close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body workflow-summary" id="workflowColumnSummaryModalBody" v-if="summary">
          <div class="summary-block" v-if="summary.products">
            <div class="summary-product-sort summary-item">
              <div class="summary-label"><h4>{{ _('Products') }}</h4></div>
              <div class="summary-value">
                <button :class="'btn btn-xs btn-' + (sortMode === 'name' ? 'dark' : 'default')" v-on:click="sortMode = 'name'">ABC</button>
                <button :class="'btn btn-xs btn-' + (sortMode === 'amount' ? 'dark' : 'default')" v-on:click="sortMode = 'amount'">321</button>
              </div>
            </div>
            <div class="summary-items summary-products">
              <div class="summary-item" v-for="product in sortedProducts">
                <div class="summary-label">{{ product.name }}</div>
                <div class="summary-value">{{ getDisplayedCount(product) }}</div>
              </div>
            </div>
          </div>
          <div class="summary-block" v-if="summary.deliveries">
            <h4 class="summarty-title">{{ _('Deliveries') }}</h4>
            <div class="summary-item">
              <div class="summary-label">{{ _('Total') }}</div>
              <div class="summary-value">{{ summary.deliveries.total }} {{ _('pcs') }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">{{ _('Pinned') }}</div>
              <div class="summary-value">{{ summary.deliveries.pinned }} {{ _('pcs') }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">{{ _('Late') }}</div>
              <div class="summary-value">{{ summary.deliveries.late }} {{ _('pcs') }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">{{ _('Now') }}</div>
              <div class="summary-value">{{ summary.deliveries.now }} {{ _('pcs') }}</div>
            </div>
          </div>
          <div class="summary-block" v-if="summary.orders">
            <h4 class="summarty-title">{{ _('Orders') }}</h4>
            <div class="summary-item">
              <div class="summary-label">{{ _('Total') }}</div>
              <div class="summary-value">{{ summary.orders.total }} {{ _('pcs') }}</div>
            </div>
            <template v-if="summary.mode === 'orders'">
              <div class="summary-item">
                <div class="summary-label">{{ _('Pinned') }}</div>
                <div class="summary-value">{{ summary.orders.pinned }} {{ _('pcs') }}</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">{{ _('Late') }}</div>
                <div class="summary-value">{{ summary.orders.late }} {{ _('pcs') }}</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">{{ _('Now') }}</div>
                <div class="summary-value">{{ summary.orders.now }} {{ _('pcs') }}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <div class="flex-row space-between">
            <div class="flex-row">
            </div>
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="close">{{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import events from '~/lib/events'
import { mapGetters } from 'vuex'

export default {
  props: ['borderRadius', 'summary'],
  data () {
    return {
      sortMode: 'name'
    }
  },
  mixins: [ events ],
  computed: {
    ...mapGetters(['allSettings', 'locale', 'clientid', 'pos']),
    settings () {
      return this.shopSettings(this.shopId)
    },
    modalClass () {
      return 'modal fade in show'
    },
    myComponentId () {
      return this.column ? this.column.identifier + '-' + this.column.component.id + '-workflowcolumnsummary' : null
    },
    products () {
      const products = []
      if (this.summary && this.summary.products) {
        for (let id of Object.keys(this.summary.products)) {
          const product = this.summary.products[id]
          products.push({
            name: product.name,
            count: product.count
          })
        }
      }
      return products
    },
    sortedProducts () {
      return this.sortMode === 'name' ? this.products.sort((a, b) => a.name > b.name ? 1 : -1) : this.products.sort((a, b) => a.count > b.count ? -1 : 1)
    }
  },
  methods: {
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    close () {
      this.$emit('closeModal')
    },
    save () {
      this.$emit('saveChanges')
    },
    getDisplayedCount (product) {
      if (!product.reservation_count) {
        return product.count + ' ' + this._('pcs')
      } else {
        return product.reservation_count + ' ' + this._('pers')
      }
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>